export default __webpack_public_path__ + "static/media/platform-4.15184dc4.png";